import React from 'react';

const EllipseOkIcon = () => (
  <svg width="84" height="80" viewBox="0 0 84 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="39" fill="#FFF7CD" stroke="#FFC107" strokeWidth="2" />
    <path d="M18 32.7692L38.8175 54L80 12" stroke="#FFC107" strokeWidth="9" />
  </svg>
);
export default EllipseOkIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/EllipseOkIcon.js